import { render, staticRenderFns } from "./AddQuestion.vue?vue&type=template&id=0b5827c0"
import script from "./AddQuestion.vue?vue&type=script&lang=js"
export * from "./AddQuestion.vue?vue&type=script&lang=js"
import style0 from "./AddQuestion.vue?vue&type=style&index=0&id=0b5827c0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports